import React, { CSSProperties, useEffect, useRef } from 'react'
import useIntersectionObserver from 'meinian-package/src/common/hooks/useIntersectionObserver'
import styles from './index.module.less'

type Panel = {
    style?:CSSProperties,
    children:any,
    title: string,
    id?:string,
    titleDir:string,
    onChange?:(val:boolean)=>void;
}

const PanelHeader = ({ title, titleDir, id, headerRef }) => {
  return <div className={styles.noviceRecommendationPanelHeader} ref={headerRef} id={id}>
    <img src={`https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/${titleDir}/${title}.png`} className="noviceRecommendationPanelHeaderTitle" />
    <div className="noviceRecommendationPanelHeaderRight">
      <img src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendationImage01/panelMeinian.png" className="noviceRecommendationPanelMeinian" />
      <div className="noviceRecommendationPanelHeaderRightPoint" />
      <div className="noviceRecommendationPanelHeaderRightPoint" />
      <div className="noviceRecommendationPanelHeaderRightPoint" />
    </div>
  </div>
}

export default ({ style, children, title, id, onChange, titleDir }:Panel) => {
  const headerRef = useRef()
  const entry:any = useIntersectionObserver(headerRef, {})
  useEffect(() => {
    if (entry?.isIntersecting) {
      onChange?.(true)
    }
  }, [entry])

  return <section className={styles.noviceRecommendationPanel} style={style}>
    <div className="noviceRecommendationPanelFg" />
    <div className="noviceRecommendationPanelBg">
      <PanelHeader title={title} id={id} headerRef={headerRef} titleDir={titleDir} />
      {children}
    </div>
  </section>
}
